/**
 * Route: /commissions — B7.1
 *
 * Layout route for Commissions section.
 * Child routes:
 *   /commissions         - Shares list (SplitsPage)
 *   /commissions/new     - New split wizard
 *   /commissions/:id     - Split detail
 */
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/commissions')({
  component: CommissionsLayout,
})

function CommissionsLayout() {
  return <Outlet />
}